import { render, staticRenderFns } from "./SharedResources.vue?vue&type=template&id=2b38a1de"
import script from "./SharedResources.vue?vue&type=script&lang=js"
export * from "./SharedResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports